module.exports = __webpack_public_path__ + "img/15.2e2b5e8d.png";